export default [
  {
    id: 1,
    customer_type_id: 1,
    customer_type_name: 'primary',
    name: 'Primary',
  },
  {
    id: 2,
    customer_type_id: 2,
    customer_type_name: 'co-applicant',
    name: 'Spouse',
  },
  {
    id: 3,
    customer_type_id: 2,
    customer_type_name: 'co-applicant',
    name: 'Roommate (Responsible)',
  },
  {
    id: 4,
    customer_type_id: 3,
    customer_type_name: 'occupant',
    name: 'Child (Non-Responsible)',
  },
  {
    id: 5,
    customer_type_id: 3,
    customer_type_name: 'occupant',
    name: 'Other (Non-Responsible)',
  },
  {
    id: 6,
    customer_type_id: 4,
    customer_type_name: 'guarantor',
    name: 'Guarantor',
  },
  {
    id: 22319,
    customer_type_id: 1,
    customer_type_name: 'primary',
    name: 'Primary 2',
  },
];
